<br />
<div>
  <ng-container id="yanMenü">
    <ul>
      <li>
        <a class="nav-item nav-link" (click)="visibleBBF()">
          Buluş Bildirim Formu
        </a>
      </li>
      <li>
        <a class="nav-item nav-link" (click)="visibleHak()"
          >Hak Talebi Karar Formu</a
        >
      </li>
      <li>
        <a class="nav-item nav-link" (click)="visibleUlke()"
          >Ülke Çıkış Karar Formu</a
        >
      </li>
    </ul>
  </ng-container>
</div>

<br />
<div *ngIf="showBBF" id="text" style="margin-left: 21%; box-sizing: border-box">
  <div id="contentToConvert" #contentToConvert>
    <p></p>
    <h1>Buluş Bildirim Formu</h1>
    <p></p>
    <table style="border: 1px solid black">
      <tr>
        <td style="width: 20%">
          <strong>Buluş Başlığı</strong>
          <p>
            <em>
              (Marka niteliğindeki terimleri içerecek şekilde olmamalıdır.)</em
            >
          </p>
        </td>
        <td style="width: 80%">
          <textarea type="text" rows="1" cols="42"> </textarea>
        </td>
      </tr>
      <tr>
        <td style="width: 20%"><strong>Buluş Bildirim Tarihi</strong></td>
        <td style="text-align: left; width: 80%">
          <input
            type="date"
            placeholder="Buluş bildirim tarihi"
            style="width: 20%"
          />
        </td>
      </tr>
    </table>

    <p></p>

    <p></p>

    <table style="border: 1px solid black">
      <tr>
        <td style="width: 60%">
          <strong
            >Buluş Sahibi Telefon /TC Kimlik Numarası/Başvuru Sahibi
            e-posta/şahsi e-posta/Adres :</strong
          >
        </td>
        <td style="width: 10%">
          <strong>KATKI ORANI (%) </strong><em>(Toplam %100 olmalıdır.)</em>
        </td>
        <td style="width: 30%"><strong>Buluş Sahibi İMZA</strong></td>
      </tr>

      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
    </table>

    <p></p>
    <h1 style="text-align: center">
      Buluş Sahibi sayısı toplam <input type="text" style="width: 15%" /> (
      <input type="text" style="width: 5%" /> ) adettir.
    </h1>

    <p></p>
    <h3 style="text-align: center">
      <span style="color: #28384f"
        >Başvuru Sahibi Topluluk dışından Buluş Sahibi var ise aşağıdaki tabloda
        belirtiniz</span
      >
    </h3>
    <p></p>
    <table style="border: 1px solid black">
      <tr>
        <td style="width: 50%">
          <strong
            >Buluş Sahibi Telefon /Kurum e-posta/şahsi e-posta/Adres :</strong
          >
        </td>
        <td>
          <strong>Çalıştığı Başvuru Sahibi/Kurum </strong>
        </td>
        <td><strong>TC Kimlik Numarası</strong></td>
      </tr>

      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td><textarea rows="1" cols="15"></textarea></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td><textarea rows="1" cols="15"></textarea></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td><textarea rows="1" cols="15"></textarea></td>
      </tr>
    </table>
    <p></p>

    <div style="margin-left: 2%">
      <strong style="color: red">
        Söz konusu formda sorulan tüm soruların ayrıntılı bir biçimde
        açıklanması halinde;
      </strong>

      <li>
        Ulusal ve uluslararası veri tabanlarında yapılacak olan ön araştırma
        işlemi en doğru şekilde yapılabilir.
      </li>
      <li>
        Buluşun açıklandığı tarifname ve koruma kapsamını belirleyen istemler en
        iyi şekilde ifade edilebilir.
      </li>
      <li>
        Tarifname ve istemlerin en doğru şekilde ifade edilmesi sonucunda ise
        hakkın ileri sürülmesine ilişkin durumlarda yada üçüncü kişilerce
        gerçekleşecek olası hak ihlallerinde buluşun savunulması kolaylaşır.
      </li>
    </div>
    <p></p>
    <table style="border: 1px solid black">
      <tr style="border: 1px solid black">
        <td style="width: 30%">
          <strong>Anahtar Kelimeler:</strong>
          <p>
            <em>
              (Buluşu en iyi şekilde ifade ettiğini düşündüğünüz kelime ve
              kelime öbeklerini yazınız.)(Tercihen İngilizce terimler
              kullanılmalıdır.)
            </em>
          </p>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="border: 1px solid black">
      <tr style="border: 1px solid black">
        <td style="width: 30%">
          <strong>Buluşun ilgili olduğu teknik alan: </strong>
          <p>
            <em>
              (Buluşun ne ile ilgili olduğunu yani hangi ürünle, hangi yöntemle
              ya da hangi sanayi kolu ile ilgili olduğunu belirtiniz.)
            </em>
          </p>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="border: 1px solid black">
      <tr>
        <td style="width: 30%">
          <strong>Önceki Teknik:</strong>
          <p>
            <em>
              (Buluş konusunun ilgili olduğu teknik alanda var olan uygulamalar,
              benzer niteliğe Sahib ürünler, biliniyor ise patentler ve diğer
              yayınları belirtiniz.)
            </em>
          </p>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="border: 1px solid black">
      <tr>
        <td style="width: 30%">
          <strong>Önceki Teknikte Saptanan Teknik Sorunlar: </strong>
          <p>
            <em>
              (İlgili buluştan önceki uygulamalarda karşılaşılan sorunları
              açıklayınız.)
            </em>
          </p>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="border: 1px solid black">
      <tr>
        <td style="width: 30%">
          <strong>Buluş ile elde edilen avantajlar:</strong>
          <p>
            <em>
              (Önceki teknikte yer alan uygulamalarda karşılaşılan sorunlara
              karşı buluşun sağladığı avantajları belirtiniz.)
            </em>
          </p>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>

    <table style="border: 1px solid black">
      <tr>
        <td style="width: 30%">
          <strong>Buluşa ilişkin ayrıntılı teknik açıklama:</strong>
          <p>
            <em>
              (Buluşa ilişkin tüm teknik özelliklere ayrıntılı bir biçimde yer
              verilmelidir. Buluş bir ürün ise bu ürünün tüm parçalarından, bir
              yöntem ise yöntemin tüm basamaklarından bahsediniz. Buluşu
              oluşturan unsurların her birinin işlevini açıklayınız)
            </em>
          </p>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="border: 1px solid black">
      <tr>
        <td style="width: 30%">
          <strong
            >Buluşa ilişkin teknik alandaki rakip firmaların isimleri:
          </strong>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="border: 1px solid black">
      <tr>
        <td style="width: 15%">
          <strong>Buluşa ilişkin görsel:</strong>
        </td>
        <td style="width: 85%">
          <div style="text-align: left">
            <div [innerHtml]="msg" *ngIf="msg" style="color: red"></div>
            <div>
              <img [src]="url" *ngIf="url" width="600" height="600" />
            </div>
            <p>
              <input type="file" (change)="selectFile($event)" />
            </p>
          </div>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="border: 1px solid black">
      <tr>
        <td style="width: 30%">
          <strong>Buluşun daha önce ifşa edilme durumu: </strong>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="border: 1px solid black">
      <tr>
        <td style="width: 30%">
          <strong
            >Buluşun sözlü-yazılı yayını, tanıtımı ya da satışı gerçekleşti mi?
          </strong>
        </td>
        <td style="width: 70%">
          <span
            >EVET/HAYIR(EVET ise nerede ve ne zaman gerçekleştiğini
            açıklayınız)</span
          >
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
  </div>
  <button
    ngxPrint
    printSectionId="contentToConvert"
    class="btn"
    (click)="onToggle()"
    style="
      margin-left: auto;
      margin-right: 10%;
      font-size: 18px;
      display: block;
      background-color: #0275d8;
    "
  >
    PDF çıktısı al
  </button>
</div>
<div
  *ngIf="showHakTalebiKarar"
  id="text"
  style="margin-left: 21%; box-sizing: border-box"
>
  <div id="haktalep" #haktalep>
    <p></p>
    <h1>Buluş Hak Talebi Karar Formu</h1>
    <p></p>
    <table style="border: 1px solid black; width: 100%">
      <tr>
        <td style="width: 20%">
          <strong>Buluş Başlığı</strong>
          <p>
            <em style="font: size 10px">
              (Marka niteliğindeki terimleri içerecek şekilde olmamalıdır.)</em
            >
          </p>
        </td>
        <td>
          <textarea type="text" style="width: 95%" rows="1" cols="42">
          </textarea>
        </td>
      </tr>
    </table>
    <table style="border: 1px solid black; width: 100%">
      <tr>
        <td style="width: 20%"><strong>Buluş Bildirim Tarihi</strong></td>
        <td style="width: 80%; text-align: left">
          <input
            type="date"
            placeholder="Buluş bildirim tarihi"
            style="width: 20%"
          />
        </td>
      </tr>
    </table>
    <table style="border: 1px solid black; width: 100%">
      <tr>
        <td style="width: 20%">
          <strong
            >Başka bir şahıs, firma veya üniversite ile işbirliği var
            mıdır?</strong
          ><em>(Evet ise detaylandırın)</em>
        </td>
        <td>
          <textarea type="text" style="width: 95%" rows="5" cols="42">
          </textarea>
        </td>
      </tr>
    </table>

    <p></p>

    <p></p>
    <div style="margin-left: 2%">
      <h2 style="color: #28384f; margin-left: -1%">
        Aşağıda belirtilen tabloda A,B ve C durumlarından talep edilen kutu
        işaretlenmelidir.
      </h2>
      <p></p>
      <p style="margin-left: -1%; font-size: 18px; color: #28384f">
        Seçeneklerin detaylı açıklaması:
      </p>

      <span style="color: #28384f">A Seçeneği:</span>
      Kanuna göre patent başvurusu yapılması ve hak Sahibliği Başvuru Sahibi
      tarafından alınması durumunda Buluş sahiplerine “Çalışan Buluşlarına,
      Yükseköğretim Kurumlarında Gerçekleştirilen Buluşlara ve Kamu Destekli
      Projelerde Ortaya Çıkan Buluşlara Dair Yönetmelik” ’te belirtilen esaslar
      çerçevesinde ödeme yapılır.
      <p></p>
      <span style="color: #28384f">B Seçeneği:</span>
      Patent başvurusu yapılmadan buluşun gizli tutulmasına karar verilirse A
      maddesindeki durumların tamamı yine geçerli olacaktır. Üretimde olan
      ürünlerde elde edilen gelirden pay verilmesi süresinin sınırı kanunda
      belirtilmemiştir.
      <p></p>
      <span style="color: #28384f">C Seçeneği:</span>
      Söz konusu buluşa ilişkin Başvuru Sahibin bir hak talebi olmayacağına
      karar verilirse buluş serbest kalır ve Buluş Sahibi tarafından
      kullanılabilir veya Buluş Sahibi tarafından 3.kişilere satılabilir.
    </div>

    <p></p>

    <h3 style="margin-left: 2%">Lütfen ilgili seçeneği işaretleyiniz:</h3>

    <table style="border: 1px solid black; width: 100%">
      <tr style="width: 100%">
        <td style="border: 1px solid black; width: 90%; text-align: left">
          <strong
            >A. Patent başvurusu yapılsın ve hak Sahibi Şirket olsun.</strong
          >
        </td>

        <td style="border: 1px solid black; width: 10%">
          <input
            type="radio"
            name="radio1"
            style="height: 20px; width: 20px; margin-left: 35%; margin-top: 5%"
          />
        </td>
      </tr>
    </table>
    <table style="border: 1px solid black; width: 100%">
      <tr style="width: 100%">
        <td style="border: 1px solid black; width: 90%; text-align: left">
          <strong>B. Buluş gizli tutulsun ve hak Sahibi Şirket olsun.</strong>
        </td>

        <td style="border: 1px solid black; width: 10%">
          <input
            type="radio"
            name="radio1"
            style="height: 20px; width: 20px; margin-left: 35%; margin-top: 5%"
          />
        </td>
      </tr>
    </table>
    <table style="border: 1px solid black; width: 100%">
      <tr style="width: 100%">
        <td style="border: 1px solid black; width: 90%; text-align: left">
          <strong
            >C. Patent başvurusu yapılsın ve hak Sahibi Buluşçular
            olsun.</strong
          >
        </td>

        <td style="border: 1px solid black; width: 10%">
          <input
            type="radio"
            name="radio1"
            style="height: 20px; width: 20px; margin-left: 35%; margin-top: 5%"
          />
        </td>
      </tr>
    </table>

    <p></p>
    <table style="border: 1px solid black; width: 100%">
      <thead style="background-color: #28384f; color: white">
        <tr>
          <th style="border: 1px solid black">Onaylayan İsim-Ünvan</th>
          <th style="border: 1px solid black">Tarih-İmza</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="border: 1px solid black; height: 150px"></td>
          <td style="border: 1px solid black; height: 150px"></td>
        </tr>
      </tbody>
    </table>
    <p></p>
  </div>
  <button
    ngxPrint
    printSectionId="haktalep"
    class="btn"
    (click)="onToggle()"
    style="
      margin-left: auto;
      margin-right: 10%;
      font-size: 18px;
      display: block;
      background-color: #0275d8;
    "
  >
    PDF çıktısı al
  </button>
</div>
<div
  *ngIf="countryDecision"
  id="text"
  style="margin-left: 21%; box-sizing: border-box"
>
  <div id="ülkeÇıkış" #ülkeÇıkış>
    <p></p>
    <h1>Ülke Çıkış Karar Formu</h1>
    <p></p>
    <table style="border: 1px solid black">
      <tr>
        <td style="width: 20%">
          <strong>Buluş Başlığı</strong>
          <p>
            <em style="font: size 10px">
              (Marka niteliğindeki terimleri içerecek şekilde olmamalıdır.)</em
            >
          </p>
        </td>
        <td>
          <textarea type="text" style="width: 95%" rows="1" cols="42">
          </textarea>
        </td>
      </tr>
    </table>
    <table style="border: 1px solid black">
      <tr>
        <td style="width: 20%">
          <strong>Patent Başvuru Numarası</strong>
          <p>
            <em style="font: size 10px"> </em>
          </p>
        </td>
        <td>
          <textarea type="text" style="width: 95%" rows="1" cols="42">
          </textarea>
        </td>
      </tr>
    </table>
    <table style="border: 1px solid black">
      <tr>
        <td style="width: 20%">
          <strong>İlk Patent Başvurusu Tarihi</strong>
        </td>
        <td style="text-align: left">
          <input
            type="date"
            placeholder="İlk başvuru tarihi"
            style="width: 20%"
          />
        </td>
      </tr>
    </table>

    <table style="border: 1px solid black">
      <tr>
        <td style="width: 20%">
          <strong>Son Kararın Verilmesi Gereken Tarih</strong>
        </td>
        <td style="text-align: left">
          <input
            type="date"
            placeholder="Son Karar tarihi"
            style="width: 20%"
          />
        </td>
      </tr>
    </table>
    <h3 style="margin-left: 2%; color: #d70040">Önemli Açıklama:</h3>
    <p style="margin-left: 2%; margin-right: 8%">
      Yurtdışı patent süreç maliyetleri yüksek olmasından dolayı (fiyatlar
      ülkeye ve başvuru sistemine göre farklılık göstermekle birlikte 1 ülkede
      20 yıllık patent koruması maliyeti ortalama 10.000$ olarak düşünülebilir.)
      Ülke listesi belirlenirken buluşa konu olan ürünün o ülkedeki satış
      miktarı, ülkedeki rakip firmaların faal olup olmadığı ve en önemlisi bir
      buluşumuza yapılacak ihlalin o ülkede tespit yeteneğimizin olup olmadığı
      değerlendirilmelidir. Seçilen ülkede ihlali tespit edebilecek ekibimiz
      veya kaynağımız olmaması durumunda o ülkedeki korumanın firmamıza bir
      avantajı olmayacaktır. Patent ihlal davaları her ülkede ayrı ayrı açılmalı
      ve her ülkedeki maliyet değişiklik göstermekle birlikte ortalama 30.000$
      mertebesinde olabilmektedir. Bir ürüne ilişkin bir ülkede patent alınması
      o ürünü üretme serbestliğimiz ile bir ilişkisi bulunmamaktadır. Patent
      almadan da bir ürünü üretebilir, satışını yapabiliriz. Patent başvurumuz
      olması o ürünü üretme serbestliği açısından firmamıza ek avantaj
      sağlamayacaktır. Patent alınmasının tek hedefi rakip firmaların patent
      dokümanında belirtilmiş alandaki ürünün koruma olduğu ülkelerde
      üretim/satış yapmasını engellemektir. Bir nevi patentte belirtilen alanı
      koruma yapılan ülkelerde tekelimize almaktır.
    </p>
    <h3 style="margin-left: 2%; color: #28384f">Ülke Çıkış Kararı:</h3>
    <table style="border: 1px solid black; width: 97%">
      <tr>
        <td style="width: 80%"></td>
        <td style="width: 10%; border: 1px solid black">Evet</td>
        <td style="width: 10%; border: 1px solid black">Hayır</td>
      </tr>
    </table>
    <table style="border: 1px solid black; width: 97%">
      <tr>
        <td style="width: 80%">
          <strong>Ülke çıkışı yapılacak mıdır?</strong>
        </td>
        <td style="width: 10%">
          <input
            type="radio"
            name="radio1"
            style="
              height: 20px;
              width: 20px;
              margin-left: 35%;
              margin-top: 5%;
              border: 1px solid black;
            "
          />
        </td>
        <td style="width: 10%">
          <input
            type="radio"
            name="radio1"
            style="
              height: 20px;
              width: 20px;
              margin-left: 35%;
              margin-top: 5%;
              border: 1px solid black;
            "
          />
        </td>
      </tr>
    </table>
    <br />
    <h3 style="margin-left: 2%; color: #28384f">
      Ülke Çıkışı Yapılması İstenen Ülkeler
    </h3>
    <table style="border: 1px solid black; width: 97%">
      <tr>
        <td>
          <textarea type="text" style="width: 95%" rows="1" cols="42">
          </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="border: 1px solid black">
      <thead style="background-color: #28384f">
        <tr>
          <th style="color: #f8f9fb">Onaylayan İsim-Ünvan</th>
          <th style="color: #f8f9fb">Tarih-İmza</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="border: 1px solid black; height: 150px"></td>
          <td style="border: 1px solid black; height: 150px"></td>
        </tr>
      </tbody>
    </table>
    <p></p>
  </div>
  <button
    ngxPrint
    printSectionId="ülkeÇıkış"
    class="btn"
    (click)="onToggle()"
    style="
      margin-left: auto;
      margin-right: 10%;
      font-size: 18px;
      display: block;
      background-color: #0275d8;
    "
  >
    PDF çıktısı al
  </button>
</div>
